import { colorSet } from '@components/Provider';
import { makeStyles, Theme } from '@material-ui/core';

export const useSnackbarStyles = makeStyles<Theme, { marginBottom?: number }>(
  (theme) => ({
    // Mui 스타일이 !important로 적용되어 있어
    // custom 스타일에 !important 추가하지 않으면 적용 되지 않음
    containerRoot: {
      bottom: ({ marginBottom }) => (marginBottom ? marginBottom : 0)
    },
    contentRoot: {
      width: 343,
      borderRadius: 8,
      padding: '7px 20px'
    },
    variantSuccess: {
      color: `${colorSet.gray000} !important`,
      backgroundColor: `${colorSet.gray900} !important`,
      '& #client-snackbar': {
        display: 'flex',
        alignItems: 'center',
        ...theme.typography.subtitle2,
        color: colorSet.gray000,
        width: 207,
        minHeight: 36,
        wordBreak: 'break-all',
        padding: 0
      }
    },
    variantError: {
      color: `${colorSet.errorMain} !important`,
      backgroundColor: `${colorSet.errorLight} !important`,
      '& #client-snackbar': {
        display: 'flex',
        alignItems: 'center',
        ...theme.typography.subtitle2,
        color: colorSet.errorMain,
        width: 207,
        minHeight: 36,
        wordBreak: 'break-all',
        padding: 0
      }
    },
    anchorOriginBottomLeft: {
      left: 24,
      bottom: 18
    },
    anchorOriginBottomCenter: {
      bottom: 10
    },
    root: {
      left: 0,
      bottom: 0
    }
  })
);
